import { AlertGroupSelectCompanyBranchByIdOutputData } from './alert-group-select-company-branch-by-id-output-data.model';


export class AlertGroupSelectCompanyBranchByIdOutput implements IAlertGroupSelectCompanyBranchByIdOutput {
    status!: number;
    message!: string;
    data!: AlertGroupSelectCompanyBranchByIdOutputData;

    constructor(data?: IAlertGroupSelectCompanyBranchByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AlertGroupSelectCompanyBranchByIdOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertGroupSelectCompanyBranchByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectCompanyBranchByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAlertGroupSelectCompanyBranchByIdOutput {
    status: number;
    message: string;
    data: AlertGroupSelectCompanyBranchByIdOutputData;
}

